const PRODUCT_DOCUMENT_TYPE = {
	PolicyWording: 'PolWord',
	Claim: 'Claim',
	IPID: 'IPID',
	ToB: 'ToB',
	Toba: 'TOBA'
}

export default PRODUCT_DOCUMENT_TYPE
